module.exports = ".container2 {\n  background: #0F7B79; }\n"